import React from 'react';

import styles from './call_box.module.css';

const CallBox = ({ call }) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.textBox}>
          <div className={styles.topText}>
            {call === 2
              ? '도움이 필요하신가요?'
              : `더 자세한 ${call === 1 ? '소식' : '기능'}이 궁금하다면?`}
            <br />
            우노스 {call === 1 || call === 3 ? '영업팀으' : '고객센터'}로
            연락주세요.
          </div>

          {call === 2 ? (
            <div className={styles.callInfo}>
              <div className={styles.callTitle}>상담 시간</div>
              <div className={styles.callDesc}>
                <span>평일 9:00 - 20:00</span>
                <span>주말, 공휴일 10:00-19:00</span>
              </div>
            </div>
          ) : null}
          <div className={styles.infoBox}>
            <span>1800-4520</span>
            <span>
              {call === 1 || call === 3 ? '영업 1번' : '고객센터 2번'}
            </span>
          </div>
        </div>
        <div className={styles.imgBox}>
          <img
            src={
              process.env.PUBLIC_URL +
              `/imgs/etc/call_box_${call === 2 ? '2' : '1'}.png`
            }
            alt='call_img'
          />
        </div>
      </div>
    </div>
  );
};

export default CallBox;
